import { IDialogAction } from './IDialogAction';
import { DialogState } from './../models/DialogState';

export const SET_HERO = 'SET_HERO';

export class SetHeroBannerAction implements IDialogAction {
    public readonly type = SET_HERO;
    public constructor(public payload: any) {}
    public reducer(state: DialogState): any {
        state.hero = this.payload.hero;
        return state;
    }
}

export const SetHeroBannerActionTypeMapping = {
    [SET_HERO]: SetHeroBannerAction
};